<script>

import {vMaska} from "maska";


export default {
  data() {
    return {
      email: '',
      pw: '',
    }
  },
  name: "LogIn",
  directives: {maska: vMaska},
  methods: {
    async login() {
      if (!this.canProceed()) {
        this.$swal.fire({
          icon: 'error',
          title: 'Credenciales Invalidas',
          text: ''
        })
        return
      }
      try {
        let data = {email: this.email, pw: this.pw}
        let result = await this.$api.get("/login", { params: data
        });

        if (result.status === 200) {
          await this.$router.push("scene")
        }

      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'Credenciales Invalidas',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
        this.email = ""
        this.pw = ""

      }
    },
    validateEmail() {
      this.email = this.email.replace(/[^\w.@-]| /g, '')
      this.email = this.email.toLowerCase()
      const atSymbolIndex = this.email.indexOf('@')
      if (atSymbolIndex !== -1) {
        this.email = this.email.slice(0, atSymbolIndex + 1) + this.email.slice(atSymbolIndex + 1).replace(/@/g, '')
      }
      while (this.email.includes('..')) {
        this.email = this.email.replace('..', '.')
      }
    },
    canProceed() {
      if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return false
      }
      return this.pw.length >= 10;
    },
    async amILoggedIn(){
      try {
        let res = await this.$api.get("/auth/users/me");
        if (res.status.toString() === "200") {
          this.usrdata = res.data
          this.$store.commit('updateThisUserData', this.usrdata)
          this.$router.push('/scene')
        }
      } catch (error) {
        console.log("can't get user data")
      }
    }
  },
  created() {
    this.amILoggedIn()
  }
}

</script>

<template>
  <div class="login-container noselect">
    <div class="background-login-shadow">
      <div class="logo_container">
        <img class="logo noselect" src="../assets/Logo_SDE_ES-Nom.png" alt="sde-logo">
      </div>
      <h1>ADMIA</h1>
      <h1>Ingreso al sistema</h1>
      <form class="Form">
        <input type="email" v-model="email" v-on:input="validateEmail"
               placeholder="Ingrese su correo electronico" autocomplete="username">

        <input type="password" v-model="pw"
               placeholder="Ingrese su contraseña" autocomplete="current-password">
        <button type="submit" @click.prevent="login" v-bind:disabled="!canProceed()">Ingresar</button>
      </form>
      <div style="margin-top: 20px; font-size: 13px;">
        <router-link to="/regPwd" class="regPwdLink">¿Olvido su contraseña? ¿Primera vez en el sitio?</router-link>
      </div>
    </div>
  </div>

</template>

<style>

.regPwdLink {
  color: #273474;
}

.logo_container {
  display: flex;
  justify-content: center;
}

.logo {
  width: 180px;
}

.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  transform: translateY(-5%);
}

.background-login-shadow {
  min-height: 292px;
  width: 356px;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 30px;
  border-radius: 30px;
}

</style>
